(function () {
  'use strict';
  if (window.__bplConversionAnalytics) return;
  window.__bplConversionAnalytics = true;

  const push = (event, detail) => {
    const payload = Object.assign({ event, source: 'homepage' }, detail || {});
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('bpl:conversion', { detail: payload }));
  };
  const text = (element, name) => String(element?.dataset?.[name] || '').slice(0, 120);

  document.addEventListener('click', (event) => {
    const department = event.target.closest('.department-card');
    if (department) push('department_selected', { department: department.getAttribute('aria-label')?.replace(/^Shop /, '').slice(0, 80) || '' });
    const product = event.target.closest('[data-conversion="product-card-click"]');
    if (product) push('product_card_clicked', { product_id: Number(product.closest('[data-product-id]')?.dataset.productId) || undefined });
    const routine = event.target.closest('[data-conversion="routine-click"]');
    if (routine) push('routine_clicked', { routine: text(routine, 'routine') });
    const checkout = event.target.closest('#ccd-checkout-btn,[name="checkout"]');
    if (checkout) push('checkout_started');
  });
  document.addEventListener('toggle', (event) => {
    if (event.target.matches('.home-faq details') && event.target.open) push('faq_opened', { question: event.target.querySelector('summary')?.textContent.replace('+', '').trim().slice(0, 120) });
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.closest('[data-pet-finder]')) {
      push('pet_finder_used', { pet: form.querySelector('[name="pet"]:checked')?.value || '', need: form.querySelector('[name="need"]:checked')?.value || '' });
    }
    if (form.matches('[data-quick-add-form]')) {
      push('quick_add_attempted', { product_id: Number(form.closest('[data-product-id]')?.dataset.productId) || undefined });
    }
    if (form.closest('.home-signup')) push('newsletter_submitted');
  }, true);
  document.addEventListener('bpl:quick-add-success', (event) => push('quick_add_succeeded', event.detail));
  document.addEventListener('bpl:quick-add-failed', (event) => push('quick_add_failed', event.detail));
  if (document.querySelector('.home-signup__message--success')) push('newsletter_success');
}());
